module.exports = __webpack_public_path__ + "static/img/1.5c90543.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Text/1.png
// module id = 351
// module chunks = 0